'use client'

import { useEffect } from 'react'
import Image from 'next/image'
import { useAnalytics } from '@hooks/useAnalytics'
import Section from '@components/page/section'
import { getCommonTrackObject } from '@utils/trackUtils'
import GirlCareful from 'public/images/girl-careful.svg'

import { colors } from '@styles/_colors'
import styles from './ErrorSection.module.scss'

type Props = {
  title?: string
  description?: string
}

const ErrorSection = ({
  title = 'Aconteceu um erro.',
  description = 'Tente acessar a página novamente em alguns instantes'
}: Props) => {
  const { page } = useAnalytics()

  useEffect(() => {
    page('ErrorPage', getCommonTrackObject())
  }, [page])

  return (
    <Section
      pageSection="error-section"
      padding={false}
      extraClasses={styles.container}
      backgroundColor={colors.global.secondary['100']}
      sectionExtraClasses={styles['section-container']}
    >
      <div className={styles.image}>
        <Image src={GirlCareful} alt={'Menina com camiseta do Asaas'} />
      </div>
      <div className={styles['text-container']}>
        <h4 className={styles.title}>{title}</h4>
        <div className={styles.content}>{description}</div>
      </div>
    </Section>
  )
}

export default ErrorSection
